export const USER_CLEAR_DATA = "USER_CLEAR_DATA";
export const USER_CUSTOM_DATA_SUCCESS = "USER_CUSTOM_DATA_SUCCESS";
